import React from "react";
import { func, bool } from "prop-types";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Col,
  Row,
} from "reactstrap";
import "./emailNotificationTextModal.css";
import { CustomCheckBox } from "../../../../components/common/CusomMUIComponents";
import { IconButton } from "@material-ui/core";
import { CloseIcon } from "../../../../assets";
import useRoles from "../../../../components/hooks/useRoles";

const EmailNotificationTextModal = ({
  isOpen,
  toggle,
  recipients,
  fullText,
  subject,
  handleSave,
  changeText,
  changeSubject,
  changeRecipientsValue,
  isActive,
  placeholders,
  changeEmailNotificationActive,
}) => {
  const { isCustomerSupport } = useRoles();
  return (
    <React.Fragment>
      <Modal style={{ maxHeight: "70vh" }} isOpen={isOpen}>
        <ModalHeader
          close={
            <IconButton onClick={toggle} style={{ padding: 8 }}>
              <CloseIcon />
            </IconButton>
          }
          className="border-0"
        >
          Email Notification
        </ModalHeader>
        <ModalBody className="border-0">
          <Row>
            <Col lg={6} className="p-0">
              <label htmlFor="recipientsid">
                Recipients (Please divide multiple e-mails with ”;”)
              </label>
              <Input
                className="mb-2"
                id="recipientsid"
                name="recipients"
                defaultValue={recipients}
                onChange={changeRecipientsValue}
                disabled={isCustomerSupport}
              />
            </Col>
            <Col lg={6} className="p-0">
              <div className="form-group form-inline float-right">
                <label>
                  <CustomCheckBox
                    id="activeid"
                    checked={isActive}
                    type="checkbox"
                    name="active"
                    onChange={changeEmailNotificationActive}
                    disabled={isCustomerSupport}
                  />
                  Active
                </label>
              </div>
            </Col>
          </Row>
          <Col lg={6} className="p-0">
            <label htmlFor="subjectid">Subject</label>
            <Input
              type="input"
              id="subjectid"
              className="mb-2"
              name="subject"
              onChange={changeSubject}
              defaultValue={subject}
              disabled={isCustomerSupport}
            />
          </Col>
          <Col lg={6} className="p-0">
            <label htmlFor="placeholdersid">Placeholders</label>
            <Input
              type="input"
              id="placeholdersid"
              disabled="disabled"
              className="mb-2"
              name="placeholders"
              defaultValue={placeholders}
            />
          </Col>

          <label htmlFor="fulltextid">Email text</label>
          <Input
            rows="10"
            id="fulltextid"
            type="textarea"
            className="mb-2"
            name="fullText"
            onChange={changeText}
            defaultValue={fullText}
            disabled={isCustomerSupport}
          />
        </ModalBody>
        <ModalFooter style={{ marginRight: 20 }} className="border-0">
          <Button
            className="email-notification-modal-button cancel-button"
            onClick={toggle}
          >
            Cancel
          </Button>
          <Button
            className="email-notification-modal-button confirm-button"
            onClick={() => handleSave()}
            disabled={isCustomerSupport}
          >
            Save
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

EmailNotificationTextModal.propTypes = {
  isOpen: bool.isRequired,
  toggle: func.isRequired,
  handleSave: func.isRequired,
};

export default EmailNotificationTextModal;



// WEBPACK FOOTER //
// ./src/features/organization/components/email-notification-text-modal/EmailNotificationTextModal.jsx